import { cn } from "@/lib/utils";

/**
 * Lightweight determinate progress bar (plain elements — no native form control, no extra deps).
 * Pass `value` 0–100, or `null` for an indeterminate (full-width, dimmed) bar.
 */
function Progress({
  value,
  className,
}: {
  value: number | null;
  className?: string;
}) {
  const pct = value == null ? 100 : Math.max(0, Math.min(100, value));
  return (
    <div
      role="progressbar"
      aria-valuenow={value ?? undefined}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn("bg-muted relative h-2 w-full overflow-hidden rounded-full", className)}
    >
      <div
        className={cn(
          "bg-primary h-full rounded-full transition-all duration-200 ease-out",
          value == null && "opacity-50"
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}

export { Progress };
